import clsx from 'clsx';
import type { InputSwitchChangeEvent } from 'primereact/inputswitch';
import { InputSwitch } from 'primereact/inputswitch';
import ErrorLabel from '../labels/error-label';

export interface ToggleButtonProps {
  checked: boolean;
  className?: string;
  disabled?: boolean;
  error?: string;
  id?: string;
  /** Sets the id of the inner <input>, so a sibling <label htmlFor> can target it. */
  inputId?: string;
  name?: string;
  tooltip?: string;
  tooltipPosition?: 'top' | 'bottom' | 'left' | 'right';
  onChange?: (value: boolean) => void;
}

function ToggleButton(props: ToggleButtonProps) {
  const { className, error, onChange, tooltipPosition, ...rest } = props;

  const onToggle = (event: InputSwitchChangeEvent) => {
    onChange?.(Boolean(event.value));
  };

  const toggleButtonClasses = clsx('odin', { 'p-invalid': error }, className);

  return (
    <div className="odin-toggle-button__wrapper">
      <InputSwitch
        {...rest}
        className={toggleButtonClasses}
        onChange={onToggle}
        tooltipOptions={{
          position: tooltipPosition ?? 'bottom',
          className: 'odin-toggle-button__tooltip',
        }}
      />
      {error && <ErrorLabel>{error}</ErrorLabel>}
    </div>
  );
}

export default ToggleButton;
